module.exports = __webpack_public_path__ + "static/img/logo-ST-KILDA.d56e0e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-ST-KILDA.svg
// module id = byaZ
// module chunks = 1